var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonitorSvgrepoCom = function SvgMonitorSvgrepoCom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,2H2A1,1,0,0,0,1,3V17a1,1,0,0,0,1,1h9v2H8a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H13V18h9a1,1,0,0,0,1-1V3A1,1,0,0,0,22,2ZM21,16H3V4H21Z"
  })));
};
export default SvgMonitorSvgrepoCom;